export default __webpack_public_path__ + "static/media/colin_standing_canopy.5e6f15f4.jpg";